// extracted by mini-css-extract-plugin
module.exports = {"SegmentContent":"BreadcrumbBar_SegmentContent__3uoPC","BreadcrumbLabel":"BreadcrumbBar_BreadcrumbLabel__X-zgY","BreadcrumbContainer":"BreadcrumbBar_BreadcrumbContainer__2pAkm"};